import React, { useEffect, useState } from 'react';
import { api, dataBR, dataHoraBR, diasAte, inteiro, moeda, moedaCurta, nomeTenant, SITUACAO } from '../api';
import { Carregando, Chip, useToast } from '../components/Base';
import { Barras, BarraPartes } from '../components/Graficos';

export const ACOES = {
  criado: 'Empresa criada', dados: 'Cadastro', status: 'Situação', plano: 'Plano', trial: 'Teste', obs: 'Observações',
  senha: 'Senha', usuario: 'Usuário', acesso: 'Acesso ao sistema', trial_expirado: 'Teste expirado',
  plano_editado: 'Plano editado', plano_criado: 'Plano criado', admin_criado: 'Admin criado', admin_editado: 'Admin editado',
};

export default function Painel() {
  const [d, setD] = useState(null);
  const avisar = useToast();

  useEffect(() => {
    api('/painel').then(setD).catch(e => avisar(e.message, 'erro'));
  }, [avisar]);

  if (!d) return <Carregando />;
  const abrir = id => { window.location.hash = '#/empresas/' + id; };
  const g = d.graficos || {};
  const eng = d.engajamento || {};
  const totalEng = eng.d7 + eng.d30 + eng.antigo + eng.nunca;

  return (
    <>
      <div className="grid grid-4">
        <div className="cartao"><h3>Receita mensal</h3><div className="numero">{moeda(d.mrr)}<small>{d.porStatus.ativo} assinatura(s) ativa(s)</small></div></div>
        <div className="cartao"><h3>Em teste</h3><div className="numero">{d.porStatus.trial}<small>{d.trialsVencendo.length} vencem em 7 dias · {d.trialsVencidos.length} vencido(s)</small></div></div>
        <div className="cartao"><h3>Novas em 30 dias</h3><div className="numero">{d.novos30}<small>{d.total} empresas no total</small></div></div>
        <div className="cartao"><h3>Conversão do teste</h3><div className="numero">{d.conversao === null ? '—' : d.conversao + '%'}<small>{d.porStatus.suspenso} suspensas · {d.porStatus.cancelado} canceladas</small></div></div>
      </div>

      <div className="grid grid-2 secao">
        <div className="cartao">
          <h3>Novas empresas por mês</h3>
          <Barras dados={g.novasEmpresas || []} series={[{ chave: 'n', nome: 'Empresas' }]} formato={inteiro} altura={200} />
        </div>
        <div className="cartao">
          <h3>Locações criadas na plataforma</h3>
          <Barras dados={g.locacoesMes || []} series={[{ chave: 'n', nome: 'Locações' }]} formato={inteiro} altura={200} />
        </div>
      </div>

      <div className="grid grid-2 secao">
        <div className="cartao">
          <h3>Faturamento dos clientes (faturas por vencimento)</h3>
          <Barras dados={g.faturamento || []} series={[{ chave: 'emitido', nome: 'Emitido' }, { chave: 'recebido', nome: 'Recebido' }]} formato={moeda} formatoEixo={moedaCurta} altura={200} />
        </div>
        <div className="cartao">
          <h3>Uso do sistema (empresas ativas e em teste)</h3>
          <BarraPartes formato={inteiro} partes={[
            { nome: 'Entraram nos últimos 7 dias', valor: eng.d7, cor: '#1E8E3E' },
            { nome: 'Entre 7 e 30 dias', valor: eng.d30, cor: '#5BB0E6' },
            { nome: 'Há mais de 30 dias', valor: eng.antigo, cor: '#C77700' },
            { nome: 'Nunca entraram', valor: eng.nunca, cor: '#BFC7D1' },
          ]} />
          <div className="mudo pequeno" style={{ marginTop: 8 }}>{totalEng} empresa(s) consideradas.</div>
          <div className="grid grid-4" style={{ marginTop: 14 }}>
            {[['usuarios', 'Usuários'], ['clientes', 'Clientes'], ['unidades', 'Cabines'], ['locacoes', 'Locações']].map(([k, n]) => (
              <div key={k} className="mini"><div className="mudo pequeno">{n}</div><strong>{inteiro(d.totais ? d.totais[k] : 0)}</strong></div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-2 secao">
        <div className="cartao">
          <h3>Assinaturas por plano</h3>
          {(!d.porPlano || d.porPlano.length === 0) && <div className="vazio">Nenhuma assinatura ativa ainda.</div>}
          {d.porPlano && d.porPlano.length > 0 && (
            <table>
              <thead><tr><th>Plano</th><th className="num">Empresas</th><th className="num">Receita/mês</th></tr></thead>
              <tbody>
                {d.porPlano.map(p => (
                  <tr key={p.codigo}><td>{p.nome}</td><td className="num">{p.qtd}</td><td className="num">{moeda(p.mrr)}</td></tr>
                ))}
                <tr><td><strong>Total</strong></td><td className="num"><strong>{d.porStatus.ativo}</strong></td><td className="num"><strong>{moeda(d.mrr)}</strong></td></tr>
              </tbody>
            </table>
          )}
          <div className="linha" style={{ marginTop: 14 }}>
            {Object.keys(SITUACAO).map(s => (
              <a key={s} href={'#/empresas?status=' + s} className="linha" style={{ gap: 6 }}>
                <Chip status={s}>{SITUACAO[s]}</Chip><strong>{d.porStatus[s]}</strong>
              </a>
            ))}
          </div>
        </div>
        <div className="cartao">
          <h3>Empresas mais ativas (locações em 30 dias)</h3>
          {(!d.topEmpresas || d.topEmpresas.length === 0) && <div className="vazio">Nenhuma locação criada nos últimos 30 dias.</div>}
          {d.topEmpresas && d.topEmpresas.length > 0 && (
            <table>
              <thead><tr><th>Empresa</th><th>Situação</th><th className="num">Locações</th><th className="num">Cabines</th></tr></thead>
              <tbody>
                {d.topEmpresas.map(t => (
                  <tr key={t.id} className="clicavel" onClick={() => abrir(t.id)}>
                    <td>{nomeTenant(t)}</td><td><Chip status={t.status}>{SITUACAO[t.status] || t.status}</Chip></td>
                    <td className="num">{t.locacoes30}</td><td className="num">{t.unidades}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div className="grid grid-2 secao">
        <div className="cartao">
          <h3>Testes vencendo</h3>
          {d.trialsVencendo.length === 0 && d.trialsVencidos.length === 0 && <div className="vazio">Nenhum teste vence nos próximos 7 dias.</div>}
          {[...d.trialsVencidos, ...d.trialsVencendo].map(t => {
            const dias = diasAte(t.trial_fim_fmt);
            return (
              <div key={t.id} className="linha" style={{ padding: '8px 0', borderBottom: '1px solid var(--borda)', cursor: 'pointer' }} onClick={() => abrir(t.id)}>
                <div style={{ flex: 1 }}>
                  <div>{nomeTenant(t)}</div>
                  <div className="mudo pequeno">termina {dataBR(t.trial_fim_fmt)}{t.ultimo_acesso ? ` · último acesso ${dataHoraBR(t.ultimo_acesso)}` : ' · nunca entrou'}</div>
                </div>
                <Chip status={dias < 0 ? 'suspenso' : dias === 0 ? 'trial' : 'neutro'}>
                  {dias < 0 ? `venceu há ${-dias} d` : dias === 0 ? 'vence hoje' : `${dias} dias`}
                </Chip>
              </div>
            );
          })}
        </div>
        <div className="cartao">
          <h3>Últimas ações</h3>
          {d.ultimosLogs.length === 0 && <div className="vazio">Nada registrado ainda.</div>}
          {d.ultimosLogs.map(l => (
            <div key={l.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--borda)' }}>
              <div><strong>{ACOES[l.acao] || l.acao}</strong>{l.tenant_id ? <a href={'#/empresas/' + l.tenant_id}> · empresa #{l.tenant_id}</a> : ''}</div>
              <div className="mudo pequeno">{l.detalhe} — {dataHoraBR(l.criado_em)}{l.admin_email ? ` · ${l.admin_email}` : ' · automático'}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
